import { gql } from '@apollo/client';

const GET_REASONS_FOR_REPORTING_EXCLUSION = gql`
  {
    reasonsForReportingExclusion {
      id
      fieldName
    }
  }
`;
export default GET_REASONS_FOR_REPORTING_EXCLUSION;
